
import { Component, Prop, Vue, Getter, Watch } from "nuxt-property-decorator";
import {
  BIcon,
  BIconListUl,
  BIconGridFill,
  BIconGrid3x3Gap,
  BIconMap,
  BIconSortDown,
  BIconSortNumericDown,
  BIconPinMap,
} from "bootstrap-vue";
import { GenreCollection, Sorting } from "@/types/Filters";

@Component({
  components: {
    BIcon,
    BIconListUl,
    BIconGridFill,
    BIconGrid3x3Gap,
    BIconMap,
    BIconSortDown,
    BIconSortNumericDown,
    BIconPinMap,
  },
})
export default class CardSummary extends Vue {
  @Prop() totale!: number;
  @Prop() risultati_correnti!: number;
  @Prop() filter!: any;
  @Prop() current: number;

  @Getter("filter/genre") currentGenre: string;
  @Getter("listlayout/getLayout") layout: string;
  @Getter("layout/searchWrapper") searchWrapper: number;
  @Getter("layout/offset") offset: any;
  @Getter("filter/perPage") rpp!: number;

  public selected: any | null = null;
  public sort_visible: boolean = false;
  public sortingLabel: string = "";

  public updateButtonLabel(e: any) {
    this.sortingLabel = new Sorting().getLabel(e?.key, e?.value);
  }

  public risultatiCorrenti(totalResults: number, currentPage: number) {
    if (Math.ceil(totalResults / this.rpp) === currentPage) {
      return totalResults;
    }
    if (totalResults === 0) {
      return 0;
    }
    return currentPage * this.rpp;
  }

  @Watch("filter.sort", { immediate: true, deep: false })
  public onSortChanged() {
    this.sortingLabel = new Sorting().getLabel(this.filter.sort?.key, this.filter.sort?.value);
  }

  mounted() {
    this.$store.commit("listlayout/setLayoutAsList");

    this.selected = this.filter.sort;
  }

  public changeRpp(rpp: number) {
    this.$emit("change-rpp", rpp);
  }
}
